import { lendingApiFetchWithoutContentType } from '../lendingApi/lendingApiQueries';

export type TSicCode = string[];

type TCompanyQuestionHistory = {
  question: string;
  answer: string;
};

export type TCompanyQuestionRequest = {
  context: {
    sic_code?: TSicCode;
  };
  history?: TCompanyQuestionHistory[];
};

export type TCompanyQuestionResponse = {
  inference_question?: string;
  questions_complete: boolean;
};

export const postCompanyQuestion = async ({
  applicationId,
  data,
}: {
  applicationId: string;
  data: TCompanyQuestionRequest;
}): Promise<TCompanyQuestionResponse> => {
  const response = await lendingApiFetchWithoutContentType(
    `/api/ai-company-question/question-and-answer/${applicationId}`,
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
    {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
